import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=bb47ba9a&scoped=true&"
import script from "./MyOrders.vue?vue&type=script&lang=js&"
export * from "./MyOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb47ba9a",
  null
  
)

export default component.exports